<template>
  <div>
    <div v-if="cautionNotice">
      <Notice :value="cautionNotice" v-model="cautionNotice" />
    </div>
    <div class="newQuestionsBackground md:py-12 py-6 dark:bg-purple-600">
      <div class="buttonDiv">
        <h2 class="questionTitle dark:text-white">
          How do you feel today? (select all that apply)
        </h2>

        <div class="paddingButtons">
          <div data-aos="fade-left" class="checkboxes2">
            <!-- Q1-1-->

            <span
              v-if="
                $store.state.views.questionOne.checkedButtons[0] === idArry[0]
              "
            >
              <input
                type="checkbox"
                id="option1"
                v-on:click="checkboxesChecked"
                name="question1-1"
                value="Content"
                checked
              />

              <label for="option1" class="dark:text-white dark:bg-hero-purple">
                &#128515; {{ answerOptions1[0] }}</label
              >
            </span>

            <span v-else>
              <input
                type="checkbox"
                id="option1"
                v-on:click="checkboxesChecked"
                name="question1-1"
                value="Content"
              />

              <label for="option1" class="dark:text-white dark:bg-hero-purple">
                &#128515; {{ answerOptions1[0] }}</label
              >
            </span>
            <!-- Q1-2-->

            <span
              v-if="
                $store.state.views.questionOne.checkedButtons[1] === idArry[1]
              "
            >
              <input
                type="checkbox"
                id="option2"
                v-on:click="checkboxesChecked"
                name="question1-1"
                value="Great"
                checked
              />

              <label for="option2" class="dark:text-white dark:bg-hero-purple">
                &#128513; {{ answerOptions1[1] }}</label
              >
            </span>

            <span v-else>
              <input
                type="checkbox"
                id="option2"
                v-on:click="checkboxesChecked"
                name="question1-1"
                value="Great"
              />
              <label for="option2" class="dark:text-white dark:bg-hero-purple">
                &#128513; {{ answerOptions1[1] }}</label
              >
            </span>

            <!-- Q1-3-->

            <span
              v-if="
                $store.state.views.questionOne.checkedButtons[2] === idArry[2]
              "
            >
              <input
                type="checkbox"
                id="option3"
                v-on:click="checkboxesChecked"
                name="question1-1"
                value="Ok"
                checked
              />

              <label for="option3" class="dark:text-white dark:bg-hero-purple">
                &#128528; {{ answerOptions1[2] }}</label
              >
            </span>

            <span v-else>
              <input
                type="checkbox"
                id="option3"
                v-on:click="checkboxesChecked"
                name="question1-1"
                value="Ok"
              />

              <label for="option3" class="dark:text-white dark:bg-hero-purple">
                &#128528; {{ answerOptions1[2] }}</label
              >
            </span>

            <!-- Q1-4-->

            <span
              v-if="
                $store.state.views.questionOne.checkedButtons[3] === idArry[3]
              "
            >
              <input
                type="checkbox"
                id="option4"
                v-on:click="checkboxesChecked"
                name="question1-1"
                value="Stressed"
                checked
              />

              <label for="option4" class="dark:text-white dark:bg-hero-purple">
                &#128543; {{ answerOptions1[3] }}</label
              >
            </span>

            <span v-else>
              <input
                type="checkbox"
                id="option4"
                v-on:click="checkboxesChecked"
                name="question1-1"
                value="Stressed"
              />

              <label for="option4" class="dark:text-white dark:bg-hero-purple">
                &#128543; {{ answerOptions1[3] }}</label
              >
            </span>

            <!-- Q1-5-->

            <span
              v-if="
                $store.state.views.questionOne.checkedButtons[4] === idArry[4]
              "
            >
              <input
                type="checkbox"
                id="option5"
                v-on:click="checkboxesChecked"
                name="question1-1"
                value="Lonely"
                checked
              />

              <label for="option5" class="dark:text-white dark:bg-hero-purple">
                &#128542; {{ answerOptions1[4] }}</label
              >
            </span>

            <span v-else>
              <input
                type="checkbox"
                id="option5"
                v-on:click="checkboxesChecked"
                name="question1-1"
                value="Lonely"
              />

              <label for="option5" class="dark:text-white dark:bg-hero-purple">
                &#128542; {{ answerOptions1[4] }}</label
              >
            </span>

            <!-- Q1-6-->

            <span
              v-if="
                $store.state.views.questionOne.checkedButtons[5] === idArry[5]
              "
            >
              <input
                type="checkbox"
                id="option6"
                v-on:click="checkboxesChecked"
                name="question1-1"
                value="Angry"
                checked
              />

              <label for="option6" class="dark:text-white dark:bg-hero-purple">
                &#128544; {{ answerOptions1[5] }}</label
              >
            </span>

            <span v-else>
              <input
                type="checkbox"
                id="option6"
                v-on:click="checkboxesChecked"
                name="question1-1"
                value="Angry"
              />

              <label for="option6" class="dark:text-white dark:bg-hero-purple">
                &#128544; {{ answerOptions1[5] }}</label
              >
            </span>

            <!-- Q1-7-->

            <span
              v-if="
                $store.state.views.questionOne.checkedButtons[6] === idArry[6]
              "
            >
              <input
                type="checkbox"
                id="option7"
                v-on:click="checkboxesChecked"
                name="question1-1"
                value="Sad"
                checked
              />

              <label for="option7" class="dark:text-white dark:bg-hero-purple">
                &#128532; {{ answerOptions1[6] }}</label
              >
            </span>

            <span v-else>
              <input
                type="checkbox"
                id="option7"
                v-on:click="checkboxesChecked"
                name="question1-1"
                value="Sad"
              />

              <label for="option7" class="dark:text-white dark:bg-hero-purple">
                &#128532; {{ answerOptions1[6] }}</label
              >
            </span>

            <!-- Q1-8-->

            <span
              v-if="
                $store.state.views.questionOne.checkedButtons[7] === idArry[7]
              "
            >
              <input
                type="checkbox"
                id="option8"
                v-on:click="checkboxesChecked"
                name="question1-1"
                value="Upset"
                checked
              />

              <label for="option8" class="dark:text-white dark:bg-hero-purple">
                &#128533; {{ answerOptions1[7] }}</label
              >
            </span>

            <span v-else>
              <input
                type="checkbox"
                id="option8"
                v-on:click="checkboxesChecked"
                name="question1-1"
                value="Upset"
              />

              <label for="option8" class="dark:text-white dark:bg-hero-purple">
                &#128533; {{ answerOptions1[7] }}</label
              >
            </span>

            <!-- Q1-9-->

            <span
              v-if="
                $store.state.views.questionOne.checkedButtons[8] === idArry[8]
              "
            >
              <input
                type="checkbox"
                id="option9"
                v-on:click="checkboxesChecked"
                name="question1-1"
                value="Depressed"
                checked
              />

              <label for="option9" class="dark:text-white dark:bg-hero-purple">
                &#128577; {{ answerOptions1[8] }}</label
              >
            </span>

            <span v-else>
              <input
                type="checkbox"
                id="option9"
                v-on:click="checkboxesChecked"
                name="question1-1"
                value="Depressed"
              />

              <label for="option9" class="dark:text-white dark:bg-hero-purple">
                &#128577; {{ answerOptions1[8] }}</label
              >
            </span>

            <!-- Q1-10-->

            <span
              v-if="
                $store.state.views.questionOne.checkedButtons[9] === idArry[9]
              "
            >
              <input
                type="checkbox"
                id="option10"
                v-on:click="checkboxesChecked"
                name="question1-1"
                value="Anxious"
                checked
              />

              <label for="option10" class="dark:text-white dark:bg-hero-purple">
                &#128531; Anxious</label
              >
            </span>

            <span v-else>
              <input
                type="checkbox"
                id="option10"
                v-on:click="checkboxesChecked"
                name="question1-1"
                value="Anxious"
              />

              <label for="option10" class="dark:text-white dark:bg-hero-purple">
                &#128531; Anxious</label
              >
            </span>
          </div>
        </div>
      </div>
      <div
        class="buttonDiv"
        v-if="
          showNextQuestion ||
          $store.state.views.questionOne.nextPartofQuestion[0] === true
        "
      >
        <h3
          class="questionTitle dark:text-white"
          data-aos="fade-up"
          data-aos-once="true"
        >
          Using the scale below, rate the severity of your feelings
        </h3>

        <div class="radio-toolbar paddingButtons">
          <div id="sliderShow" class="slidecontainer">
            <div class="sliderLabels text-left">
              <p class="sliderEndpointLeft dark:text-gray-200">Mild</p>
              <div class="sliderLabelsInner">
                <p class="sliderEndpointMiddleLeft dark:text-gray-200">
                  Moderate
                </p>
                <p class="sliderEndpointMiddleRight dark:text-gray-200">
                  Severe
                </p>
              </div>
              <p class="sliderEndpointRight text-right dark:text-gray-200">
                Extremely severe
              </p>
            </div>
            <span
              v-if="
                $store.state.views.questionOne.checkedSlider ===
                answerOptions2[0]
              "
            >
              <input
                type="range"
                min="1"
                max="4"
                value="1"
                class="slider"
                title="Severity of your feelings Scale"
                id="myRange"
                v-on:input="sliderUpdate"
                v-bind:style="[styleIndexSlider0]"
              />

              <!--<p class="dark:text-white">{{ currMood }}</p>-->
            </span>

            <span
              v-if="
                $store.state.views.questionOne.checkedSlider ===
                answerOptions2[1]
              "
            >
              <input
                type="range"
                min="1"
                max="4"
                value="2"
                class="slider"
                id="myRange"
                v-on:input="sliderUpdate"
                v-bind:style="[styleIndexSlider1]"
              />

              <!--<p class="dark:text-white">{{ currMood }}</p>-->
            </span>
            <span
              v-if="
                $store.state.views.questionOne.checkedSlider ===
                answerOptions2[2]
              "
            >
              <input
                type="range"
                min="1"
                max="4"
                value="3"
                class="slider"
                id="myRange"
                v-on:input="sliderUpdate"
                v-bind:style="[styleIndexSlider2]"
              />

              <!--<p class="dark:text-white">{{ currMood }}</p>-->
            </span>
            <span
              v-if="
                $store.state.views.questionOne.checkedSlider ===
                answerOptions2[3]
              "
            >
              <input
                type="range"
                min="1"
                max="4"
                value="4"
                class="slider"
                id="myRange"
                v-on:input="sliderUpdate"
                v-bind:style="[styleIndexSlider3]"
              />

              <!--<p class="dark:text-white">{{ currMood }}</p>-->
            </span>
          </div>
        </div>
      </div>
      <!--
      <div
        v-if="
          $store.state.views.questionOne.nextPartofQuestion[1] === true ||
          (showCrisis &&
            $store.state.views.questionOne.checkedSlider ===
              answerOptions2[2]) ||
          (showCrisis &&
            $store.state.views.questionOne.checkedSlider ===
              answerOptions2[3]) ||
          showCrisis
        "
        class="buttonDiv"
      >
        <h2 class="questionTitle dark:text-white">Are you in crisis?</h2>
        <div class="paddingButtons">
          <div data-aos="fade-left" class="radio-toolbar">
            Q1-1-1

            <span
              v-if="
                $store.state.views.questionOne.checkedButtons[11] === idArry[10]
              "
            >
              <input
                type="radio"
                id="option1.1"
                v-on:click="setNextDisabled"
                name="question1-1-1"
                value="In Crisis"
                checked
              />

              <label
                for="option1.1"
                class="dark:text-white dark:bg-hero-purple"
              >
                {{ answerOptions3[0] }}</label
              >
            </span>

            <span v-else>
              <input
                type="radio"
                id="option1.1"
                v-on:click="setNextDisabled"
                name="question1-1-1"
                value="In Crisis"
              />

              <label
                for="option1.1"
                class="dark:text-white dark:bg-hero-purple"
              >
                {{ answerOptions3[0] }}</label
              >
            </span>
            Q1-1-2

            <span
              v-if="
                $store.state.views.questionOne.checkedButtons[11] === idArry[11]
              "
            >
              <input
                type="radio"
                id="option1.2"
                v-on:click="setNextTrue"
                name="question1-1-1"
                value="Not in Crisis"
                checked
              />

              <label
                for="option1.2"
                class="dark:text-white dark:bg-hero-purple"
              >
                {{ answerOptions3[1] }}</label
              >
            </span>

            <span v-else>
              <input
                type="radio"
                id="option1.2"
                v-on:click="setNextTrue"
                name="question1-1-1"
                value="Not in Crisis"
              />
              <label
                for="option1.2"
                class="dark:text-white dark:bg-hero-purple"
              >
                {{ answerOptions3[1] }}</label
              >
            </span>
          </div>
        </div>
      </div>
      -->
    </div>

    <div
      class="
        alignFooter
        dark:bg-hero-purple
        border-b border-gray-200
        dark:border-hero-purple
      "
    >
      <div class="footerContainer">
        <HelpDialog />

        <button
          v-if="
            isActive || $store.state.views.questionOne.nextButtonActive == true
          "
          v-on:click="nextQuestion"
          class="nextButtonQuestions"
        >
          Next
          <span class="arrow">
            <svg
              width="14"
              height="12"
              viewBox="0 0 14 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.63466 0.298041C8.45622 0.109282 8.20838 0 7.9308 0C7.38556 0 6.93945 0.447062 6.93945 0.99347C6.93945 1.27164 7.0485 1.52001 7.22694 1.69883L10.4885 4.96735H0.99135C0.446108 4.96735 0 5.41441 0 5.96082C0 6.50723 0.446108 6.95429 0.99135 6.95429H10.4984L7.23686 10.2228C7.05842 10.4016 6.94937 10.65 6.94937 10.9282C6.94937 11.4746 7.39547 11.9216 7.94072 11.9216C8.2183 11.9216 8.46613 11.8124 8.64458 11.6335L13.6013 6.66618C13.7798 6.48736 13.8888 6.23899 13.8888 5.96082C13.8888 5.68265 13.7699 5.44422 13.5914 5.26539L8.63466 0.298041Z"
                fill="#8380A8"
              />
            </svg>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../store";
// import BackButton from "./BackButton.vue";
import Notice from "./Notice.vue";
import HelpDialog from "./HelpDialog.vue";

export default {
  name: "Q1",
  components: {
    Notice,
    // BackButton,
    HelpDialog,
  },
  data() {
    HelpDialog;
    return {
      answerOptions1: {
        0: "Content",
        1: "Great",
        2: "Ok",
        3: "Stressed",
        4: "Lonely",
        5: "Angry",
        6: "Sad",
        7: "Upset",
        8: "Depressed",
        9: "Anxiety",
      },

      idArry: {
        0: "option1",
        1: "option2",
        2: "option3",
        3: "option4",
        4: "option5",
        5: "option6",
        6: "option7",
        7: "option8",
        8: "option9",
        9: "option10",
        10: "option1.1",
        11: "option1.2",
      },
      answerOptions2: {
        0: "Mild",
        1: "Moderate",
        2: "Severe",
        3: "Extremely severe",
      },
      answerOptions3: {
        0: "Yes",
        1: "No",
      },
      isActive: false,
      showNextQuestion: false,
      showCrisis: false,
      cautionNotice: false,
      arr: [],
      checkedAnswers: [],
      currMood: store.state.views.questionOne.checkedSlider,
      blank: "",

      //styling

      styleIndexSlider0: {
        background:
          "linear-gradient(to right, #2585c5 0%, #2585c5 " +
          0 +
          "%, #d3d3d3 " +
          0 +
          "%, #d3d3d3  100%)",
      },

      styleIndexSlider1: {
        background:
          "linear-gradient(to right, #2585c5 0%, #2585c5 " +
          33.3 +
          "%, #d3d3d3 " +
          33.3 +
          "%, #d3d3d3  100%)",
      },

      styleIndexSlider2: {
        background:
          "linear-gradient(to right, #2585c5 0%, #2585c5 " +
          66.6 +
          "%, #d3d3d3 " +
          66.6 +
          "%, #d3d3d3  100%)",
      },

      styleIndexSlider3: {
        background:
          "linear-gradient(to right, #2585c5 0%, #2585c5 " +
          100 +
          "%, #d3d3d3 " +
          100 +
          "%, #d3d3d3  100%)",
      },
    };
  },

  mounted: function () {
    window.onload = function () {
      this.slider = document.getElementById("myrange");
    };
    this.scrollToTop();
    this.track();
  },

  methods: {
    // track () {
    //
    // },

    track() {
      const currentURL = new URL(location.href);
      const isDemo = currentURL.searchParams.get('demo') === 'true';

      if (!isDemo) {
        this.$gtag.pageview({ page_path: "step1" });
      } else if(isDemo) {
        console.log("Demo Mode: no event tracking");
      }
    },

    sliderUpdate() {
      var slider = document.getElementById("myRange");
      var value;
      var removeCrisis;
      // const noticeFlag = store.getters.warningModal;

      if (slider.value == 1) {
        value = 0;
        slider.style.background =
          "linear-gradient(to right, #2585c5 0%, #2585c5 " +
          value +
          "%, #d3d3d3 " +
          value +
          "%, #d3d3d3  100%)";

        this.currMood = this.answerOptions2[0];
        //store.commit("setSlider", this.currMood);
        this.showCrisis = false;
        this.isActive = true;
        removeCrisis = {
          index: '["questionOne"]',
          questionNum: 1,
        };

        store.commit("removeNextQuestions", removeCrisis);
      } else if (slider.value == 2) {
        value = 33.3;
        slider.style.background =
          "linear-gradient(to right, #2585c5 0%, #2585c5 " +
          value +
          "%, #d3d3d3 " +
          value +
          "%, #d3d3d3  100%)";
        this.currMood = this.answerOptions2[1];
        //store.commit("setSlider", this.currMood);
        this.showCrisis = false;
        this.isActive = true;
        removeCrisis = {
          index: '["questionOne"]',
          questionNum: 1,
        };

        store.commit("removeNextQuestions", removeCrisis);
      } else if (slider.value == 3) {
        //if (!noticeFlag) {
        //this.showSweetAlert();
        //}

        value = 66.6;

        slider.style.background =
          "linear-gradient(to right, #2585c5 0%, #2585c5 " +
          value +
          "%, #d3d3d3 " +
          value +
          "%, #d3d3d3 100%)";
        this.currMood = this.answerOptions2[2];
        //store.commit("setSlider", this.currMood);
        store.commit("setNextButtonDeactive", '["questionOne"]');
        this.showCrisis = true;

        this.isActive = false;

        this.cautionNotice = true;
        this.scrollToBottom();
      } else {
        // if (!noticeFlag) {
        //this.showSweetAlert();
        //}
        value = 100;
        slider.style.background =
          "linear-gradient(to right, #2585c5 0%, #2585c5 " +
          value +
          "%, #d3d3d3 " +
          value +
          "%, #d3d3d3 100%)";
        this.currMood = this.answerOptions2[3];
        //store.commit("setSlider", this.currMood);
        store.commit("setNextButtonDeactive", '["questionOne"]');
        this.showCrisis = true;

        this.isActive = false;

        this.cautionNotice = true;
        this.scrollToBottom();
      }
    },
    showSweetAlert() {
      const Swal = require("sweetalert2");

      let timerInterval;
      Swal.fire({
        title: "Auto close alert!",
        html: "Please proceed to the help menu  <hr/><br/>I will close in <b></b> milliseconds.",
        timer: 3000,
        timerProgressBar: true,
        color: "#ffffff",
        background: "#261C3A",

        didOpen: () => {
          Swal.showLoading();
          const b = Swal.getHtmlContainer().querySelector("b");
          timerInterval = setInterval(() => {
            b.textContent = Swal.getTimerLeft();
          }, 100);
        },
        willClose: () => {
          clearInterval(timerInterval);
        },
      });
    },

    nextQuestion() {
      var answerArray = [];
      var activeChecked = [];

      var checkboxes = document.getElementsByName("question1-1");
      for (var i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked) {
          answerArray.push(this.answerOptions1[i]);
        }
      }

      for (i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked) {
          activeChecked[i] = checkboxes[i].id;
        } else {
          activeChecked[i] = "NULL";
        }
      }

      if (
        this.showNextQuestion ||
        store.state.views.questionOne.nextPartofQuestion[0] === true
      ) {
        //this.findCheckedID("question1-2", activeChecked, 1);
        //this.findChecked("question1-2", answerArray);
        answerArray.push(this.currMood);
        activeChecked.push(this.currMood);
        //new slider
        store.commit("setSlider", this.currMood);
        //
      }

      for (i = 0; i < answerArray.length; i++) {
        const currentURL = new URL(location.href);
        const isDemo = currentURL.searchParams.get('demo') === 'true';

        if (!isDemo) {
          this.$gtag.event("q1-answer", {
            event_category: "answers",
            event_label: answerArray[i],
          });
        } else if(isDemo) {
          console.log("Demo Mode: no event tracking");
      }
      }

      var objectForPages = {
        index: '["questionOne"]',
        ans: answerArray,
      };

      var objectForChecked = {
        questionNum: '["questionOne"]',
        checkedButtons: activeChecked,
      };
      store.commit("addAnswer", objectForPages);
      store.commit("setNextButtonActive", '["questionOne"]');
      store.commit("setChecked", objectForChecked);
      store.commit("updatePage", '["questionTwo"]');
      // store.commit("APPEND_SERVICE_TERM", objectForPages)
    },

    checkboxesChecked() {
      var slider = document.getElementById("myRange");
      if (slider != null) {
        store.commit("setSlider", this.currMood);
      }
      var checkboxes = document.getElementsByName("question1-1");
      var total = 0;

      if (
        checkboxes[3].checked ||
        checkboxes[4].checked ||
        checkboxes[5].checked ||
        checkboxes[6].checked ||
        checkboxes[7].checked ||
        checkboxes[8].checked ||
        checkboxes[9].checked
      ) {
        this.showNextQuestion = true;

        if (
          this.currMood === "Severe" ||
          this.currMood === "Extremely severe"
        ) {
          this.showCrisis = true;
        }
      } else {
        this.showNextQuestion = false;
        this.showCrisis = false;
        var objectForPageRemove = {
          index: '["questionOne"]',
          questionNum: 0,
        };
        var objectForPageRemove2 = {
          index: '["questionOne"]',
          questionNum: 1,
        };

        store.commit("removeNextQuestions", objectForPageRemove);
        store.commit("removeNextQuestions", objectForPageRemove2);
      }

      for (var i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked) {
          total = total + 1;
        }
      }

      if (total === 0) {
        this.isActive = false;
        store.commit("setNextButtonDeactive", '["questionOne"]');
      } else {
        this.isActive = true;
        /*
        if (
          this.currMood === "Severe" ||
          this.currMood === "Extremely severe"
        ) {
          this.isActive = false;
        }
        /*
        const nextButtonSpecialCase = store.getters.questionOneCheckButtons;

        if (
          this.showCrisis &&
          !(
            nextButtonSpecialCase.includes("option1.1") ||
            nextButtonSpecialCase.includes("option1.2")
          )
        ) {
          store.commit("setNextButtonDeactive", '["questionOne"]');
          this.isActive = false;
        }
        */
      }

      /*
      console.log("hello");
      this.showNextQuestion = false;
      var objectForPageRemove = {
        index: '["questionOne"]',
        questionNum: 0,
      };
      store.commit("removeNextQuestions", objectForPageRemove);
      store.commit("setNextButtonActive", '["questionOne"]');
      this.isActive = true; */
    },

    setNextTrue() {
      this.isActive = true;
    },

    setNextDisabled() {
      this.isActive = false;
      store.commit("setNextButtonDeactive", '["questionOne"]');
    },
    //adding to the crisis
    findChecked: function (name, arr) {
      var check = document.querySelector(
        "input[name = " + name + "]:checked"
      ).value;
      arr.push(check);
    },
    findCheckedID: function (name, arr, index) {
      var check = document.querySelector(
        "input[name = " + name + "]:checked"
      ).id;
      arr[index] = check;
    },
    ifOneChecked: function (name) {
      var ele = document.getElementsByName(name);

      for (var i = 0; i < ele.length; i++) {
        if (ele[i].checked === true) {
          return true;
        }
      }
      return false;
    },

    scrollToInputName: function (input_name) {
      var scrollTop = document.querySelector(
        "input[name = " + input_name + "]"
      ).scrollHeight;
      window.scrollTo({
        top: scrollTop,
        behavior: "smooth",
      });
    },
    scrollToId: function (id_name) {
      var scrollTop = document.getElementById(id_name).scrollHeight;
      window.scrollTo({
        top: scrollTop,
        behavior: "smooth",
      });
    },
    scrollToBottom: function () {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
    },

    scrollToTop: function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>
